const NON_WORD_CHARACTERS_REGEX = /\W/g;

export const replaceNonWordsWithUnderline = (text: string = "") => {
  return text.replaceAll(NON_WORD_CHARACTERS_REGEX, "_");
};
